import React, { useEffect } from "react";
import { Modal, Form, Radio, Select, Input, Button } from "antd";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_SHIPPING_POSTAL_SEARCH } from "../Apollo/graphql/Query";
import { GET_SHIPPING_COUNTRIES } from "../Apollo/graphql/Query/GetShippingCountrys";

const { Option } = Select;

// const AUSPOST_INT_SERVICES = [
//   { value: "INT_PARCEL_COR_OWN_PACKAGING", label: "COURIER" },
//   { value: "INT_PARCEL_EXP_OWN_PACKAGING", label: "EXPRESS" },
//   { value: "INT_PARCEL_STD_OWN_PACKAGING", label: "STANDARD" },
//   { value: "INT_PARCEL_AIR_OWN_PACKAGING", label: "AIR" },
// ];
// const AUSPOST_LOCAL_SERVICES = [
//   { value: "AUS_PARCEL_REGULAR", label: "REGULAR" },
//   { value: "AUS_PARCEL_EXPRESS", label: "EXPRESS" },
// ];

const SHIPPING_TYPES = [
  { value: "CHEAPEST", label: "Cheapest" },
  { value: "FASTEST", label: "Fastest" },
  { value: "BESTVALUE", label: "Best Value" },
];

const ShippingDetailsModal = ({
  isShippingModalVisible,
  handleShippingFormSubmit,
  handleClose,
  form,
  onDeliveryTypeChange,
  onOverseasChange,
  shippingDetails,
}) => {
  const { deliveryType, overseas } = shippingDetails;
  const isShipping = deliveryType === "SHIPPING";

  useEffect(() => {
    form.setFieldsValue({
      countryCode: shippingDetails.countryCode || "AU",
      country: shippingDetails.country || "AUSTRALIA",
      shippingArea: shippingDetails.shippingArea || "australia",
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // search shipping location query
  const [
    searchData,
    { data: searchD, loading: searchLoading, error: serchError },
  ] = useLazyQuery(GET_SHIPPING_POSTAL_SEARCH, {});

  const { data: searchCountries } = useQuery(GET_SHIPPING_COUNTRIES);

  const handleInputSearch = (searchquery) => {
    if (searchquery?.length >= 3) {
      searchData({
        variables: {
          search: searchquery,
        },
      });
    }
  };

  const handlePostCodeChange = (newValue: string, child: any) => {
    form.setFieldsValue({ deliveryLocation: child.children[0] });
  };

  const handleCountryChange = (event) => {
    form.setFieldsValue({ country: event.key, deliveryLocation: null, deliveryAddress: null, to: null });
  };

  const handleOverseasChange = (event) => {
    onOverseasChange(event.target.value);
    form.setFieldsValue({
      country: event.target.value === 'australia' ? 'AUSTRALIA' : null,
      countryCode: event.target.value === 'australia' ? 'AU' : null,
      deliveryLocation: null,
      deliveryAddress: null,
      to: null,
    });
  }

  return (
    <Modal
      visible={isShippingModalVisible}
      destroyOnClose={true}
      title="Change Delivery Details"
      footer={null}
      onCancel={() => {
        form.resetFields();
        handleClose();
      }}
    >
      <Form
        form={form}
        // preserve={false}
        layout="horizontal"
        onFinish={handleShippingFormSubmit}
        autoComplete="on"
      >
        <Form.Item name="deliveryType" label="Delivery Type">
          <Radio.Group
            onChange={(v) => {
              onDeliveryTypeChange(v.target.value);
            }}
          >
            <Radio value="PICKUP">Pick-Up</Radio>
            <Radio value="SHIPPING">Shipping</Radio>
          </Radio.Group>
        </Form.Item>
        {isShipping && (
          <div>
            <Form.Item name="shippingArea" label="Shipping Area">
              <Radio.Group onChange={handleOverseasChange}>
                <Radio value="australia">Australia Wide</Radio>
                <Radio value="overseas">Overseas</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="country" label="Country" hidden>
              <Input />
            </Form.Item>
            <Form.Item
              name="fullname"
              label="Full Name"
              rules={[
                {
                  required: true,
                  message: "Please input your full name",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="To Country"
              name="countryCode"
              rules={[
                {
                  required: true,
                  message: "Please select country!",
                },
              ]}
              hidden={!overseas}
            >
              <Select
                size="large"
                showSearch
                placeholder="Search"
                optionFilterProp="children"
                showArrow={false}
                onSearch={handleInputSearch}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    .toLowerCase()
                    .startsWith(input.toLowerCase())
                }
                onChange={(e, obj) => handleCountryChange(obj)}
                notFoundContent={null}
              >
                {searchCountries &&
                  searchCountries?.shippingCountries?.map((s) => (
                    <Option key={s.name} value={s.code}>
                      {s.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            {overseas && (
              <Form.Item
                label="Post/Zip Code"
                name="to"
                rules={[
                  {
                    required: true,
                    message: "Post/zip code is required!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            )}
            {!overseas && (
              <Form.Item
                label="Post/Zip Code"
                name="to"
                rules={[
                  {
                    required: true,
                    message: "Post code is required!",
                  },
                ]}
              >
                <Select
                  size="large"
                  showSearch
                  placeholder="Search your place"
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={handleInputSearch}
                  onChange={handlePostCodeChange}
                  notFoundContent={null}
                >
                  {searchLoading && (
                    <Option value="search" disabled={true}>
                      Searching....
                    </Option>
                  )}
                  {serchError && (
                    <Option value="error" disabled={true}>
                      data not found
                    </Option>
                  )}
                  {searchD &&
                    searchD?.shippingPostalSearch?.map((s) => (
                      <Option key={s.id} value={`${s.postcode}_${s.id}`}>
                        {s.location} {s.state} {s.postcode}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            <Form.Item
              label="City"
              name="deliveryLocation"
              rules={[
                {
                  required: true,
                  message: "Please Enter the delivery city!",
                },
              ]}
            >
              <Input size="large" placeholder="Enter your City" />
            </Form.Item>
            <Form.Item
              label="Address"
              name="deliveryAddress"
              rules={[
                {
                  required: true,
                  message: "Please Enter the delivery address!",
                },
              ]}
            >
              <Input size="large" placeholder="Enter the delivery address" />
            </Form.Item>
            <Form.Item
              label="Service Type"
              name="shippingType"
              rules={[
                {
                  required: true,
                  message: "Please Select the Service Type!",
                },
              ]}
            >
              <Select
                placeholder="Select the service type"
                size="large"
                showArrow={false}
              >
                {/* {overseas
                  ? AUSPOST_INT_SERVICES.map((single) => (
                      <Option value={single.value}>{single.label}</Option>
                    ))
                  : AUSPOST_LOCAL_SERVICES.map((single) => (
                      <Option value={single.value}>{single.label}</Option>
                    ))} */}
                {SHIPPING_TYPES.map((single) => (
                  <Option value={single.value}>{single.label}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        )}
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: "100%",
              fontSize: "18px",
              height: "46px",
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            Confirm
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ShippingDetailsModal;
